import script from "./bills.vue?vue&type=script&setup=true&lang=js"
export * from "./bills.vue?vue&type=script&setup=true&lang=js"

import "./bills.vue?vue&type=style&index=0&id=41337129&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41337129"]])

export default __exports__